import ApplicationsSignature from './applications-signature';

export default ApplicationsSignature;
